import Vue from 'vue'

export const eventBus = new Vue({
    methods: {
        viewAllFoldersFiles(type) {
            this.$emit('viewAllFoldersFiles', type)
        },
        
        documentManagerLoading(type, value) {
            this.$emit('isDocumentManagerLoading', {type, value})
        },

        searchFoldersFiles(value) {
            this.$emit('searchFoldersFiles', value)
        },

        sortingColumn(item, value) {
            this.$emit('sortingColumn', {item, value})
        },

        toggleListGridView(value) {
            this.$emit('toggleListGridView', value)
        },

        reloadFolderFile(value, type = 'default') {
            this.$emit('reloadFolderFile', {valuecheck: value, typecheck: type})
        },
        openUnlockModal(value) {
            this.$emit('openUnlockModal', value)
        },
        sideBarLoading(value) {
            this.$emit('isSideBarLoading', value)
        },
        manageSortingAtSearchUser() {
            this.$emit('manageSortingAtSearchUser')
        },
    }
});
  